module.exports = __webpack_public_path__ + "img/tx.rate.daily.223a63b0.png";